// Quick Settings tunable: a labelled text value block.
//
// Editable value field named EXACTLY 'VALUE' (AC16 guard — see numberInput.js). Output type
// 'String'. Pattern: before_purchase/purchase.js:7-24 + trade/components.js:186-224.
import { translate } from '../../../../../common/i18n';
import theme from '../../theme';

Blockly.Blocks.text_input = {
    init: function init() {
        this.appendDummyInput()
            .appendField(new Blockly.FieldTextInput(translate('Label')), 'LABEL')
            .appendField(new Blockly.FieldTextInput(''), 'VALUE');
        this.setOutput(true, 'String');
        this.setColour(theme.subBlockColor);
        this.setTooltip(translate('A text value editable from Quick Settings.'));
    },
};

Blockly.JavaScript.text_input = block => {
    const value = String(block.getFieldValue('VALUE') || '');
    const escaped = value.replace(/\\/g, '\\\\').replace(/'/g, '\\\'');
    return [`'${escaped}'`, Blockly.JavaScript.ORDER_ATOMIC];
};
